import { ClaimType } from "./ClaimType";

export const ClaimTypeUri : Record<keyof typeof ClaimType, string> = {
  groupsid: "http://schemas.microsoft.com/ws/2008/06/identity/claims/groupsid",
  primarygroupsid: "http://schemas.microsoft.com/ws/2008/06/identity/claims/primarygroupsid",
  role: "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
}
